import { render } from "./WebhookTree.vue?vue&type=template&id=b5d9dea6"
import script from "./WebhookTree.vue?vue&type=script&lang=js"
export * from "./WebhookTree.vue?vue&type=script&lang=js"
script.render = render

export default script